import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Fear of emotional reactions</div>
                                            <p>This is common, whether the emotional reaction is our own or
                                                others’. Try to put yourself in the other person’s shoes and
                                                deliver your message in a way that’s clear, but not damaging. In
                                                a difficult performance appraisal, for example, it’s important
                                                that the employee understands what is unacceptable but also
                                                feels advised or guided rather than merely criticised. Fear of
                                                your own emotional reactions is also common.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Try to anticipate any emotional
                                                    reactions you may have
                                                </div>
                                                <p>Think about how you will recognise them when they start to
                                                    appear (e.g. will you feel a tense feeling in your stomach,
                                                    or a burning feeling in your throat?). Increasing your
                                                    awareness of your emotional states will help you manage them
                                                    when they do occur. If you find yourself becoming
                                                    overwhelmed with emotions then be honest with the person you
                                                    are speaking with and explain how the situation is making
                                                    you feel.</p>
                                            </div>
                                            <div className="border_subtitle">Fear of feeling bad</div>
                                            <p>Often we don’t talk about sensitive issues with someone, because
                                                we’re worried it’ll make them feel bad about themselves but,
                                                while this may appear kind or polite, it’s more to do with our
                                                own fear of not being liked in return!</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Part of conquering this fear is
                                                    recognising that giving these difficult messages to people
                                                    is not a negative event
                                                </div>
                                                <p>The reason you are giving the message is to improve the
                                                    situation. Focus on the positive reasons for the
                                                    conversation and you will gain the confidence of the person
                                                    you are talking to.</p>
                                            </div>
                                            <div className="border_subtitle">Fear of making the problem
                                                worse/retribution
                                            </div>
                                            <p>Fear of making the problem worse and inviting retribution stems
                                                from a fear of being thought incompetent. Confidence in your own
                                                ability to deal with a situation comes mostly from knowing why
                                                you need to do so, in the first place.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Focus on the positive reasons
                                                    for approaching this situation and this attitude will shine
                                                    through
                                                </div>
                                            </div>
                                            <div className="border_subtitle">Isn’t it easier just to put up with
                                                it?
                                            </div>
                                            <p>Well, yes…but no. The consequences of doing nothing can be far
                                                worse than any momentary qualms you might have when you just
                                                deal with stuff!</p>
                                            <div className="circle_title">
<span className="heading">
<img src={require('@images/browndot.jpg')} alt=""/></span>
                                                <span
                                                    className="heading">WHY WE SHOULDN’T AVOID DIFFICULT CONVERSATIONS</span>
                                            </div>
                                            <p>Avoiding difficult conversations at work might be the convenient
                                                approach, but you’re less likely to get the best outcome. Here
                                                are some reasons not to avoid a difficult conversation.</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}